import React from 'react';
import {IconName, IconPrefix} from '@fortawesome/fontawesome-common-types';

import {Button, Icon, Text, Heading} from '@albert-io/atomic';
import ManageRosterContext from 'client/Classrooms/Classroom/Teacher/ManageRoster/ManageRoster.context';

interface InviteOption {
  title: string;
  description: string;
  colors: {
    background: string;
    color: string;
  };
  icon: IconName | [IconPrefix, IconName];
  buttonText: string;
  modalToShow: string;
}

const items: InviteOption[] = [
  {
    title: 'Email',
    description:
      'Add multiple emails or upload a CSV. Students will receive a class invitation link in their email inbox.',
    colors: {background: '#FEF2F3', color: '#E87077'},
    icon: 'envelope',
    buttonText: 'Invite by email',
    modalToShow: 'email'
  },
  {
    title: 'Google Classrooms',
    description:
      'Invite students from Google Classroom. Students can accept the invite by visiting their class dashboard on Albert.',
    colors: {background: '#F6FFF3', color: '#80D166'},
    icon: ['fab', 'google'],
    buttonText: 'Import from Google',
    modalToShow: 'googleClassroom'
  },
  {
    title: 'Class code',
    description: 'Students can join the class using the class enrollment code.',
    colors: {background: '#FDF7F0', color: '#EEC28F'},
    icon: 'barcode-read',
    buttonText: 'Show code',
    modalToShow: 'classCode'
  },
  {
    title: 'LMS',
    description: 'Import students from Canvas, Blackboard, Moodle, or Brightspace.',
    colors: {background: '#F8F4FF', color: '#9770E8'},
    icon: 'school',
    buttonText: 'Import from LMS',
    modalToShow: 'LMS'
  }
];

interface Props {
  title: string;
  description: string;
  icon: IconName | [IconPrefix, IconName];
  buttonText: string;
  colors: {
    background: string;
    color: string;
  };
  modalToShow: string;
}

const InviteStudentsCard = ({title, description, icon, buttonText, colors, modalToShow}: Props) => {
  // @ts-ignore
  const {setModalToShow} = React.useContext(ManageRosterContext);
  return (
    <li className='invite-cards__item u-pad_3 u-display_flex u-flex-direction_column u-align-items_flex-start u-justify-content_space-between'>
      <div className='u-display_flex u-flex-direction_column'>
        <div
          className='invite-cards__item__icon u-mar-b_3 u-display_flex u-align-items_center u-justify-content_center'
          style={colors}
        >
          <Icon icon={icon} color='inherit' />
        </div>
        <Heading size='s' className='u-mar-b_1'>
          {title}
        </Heading>
        <Text emphasis='lowest'>{description}</Text>
      </div>

      <Button
        className='u-align-self_flex-end u-mar-t_4'
        onClick={() => setModalToShow(modalToShow)}
      >
        {buttonText}
      </Button>
    </li>
  );
};

const InviteStudentsCards = () => {
  return (
    <>
      <Heading size='m'>Invite options</Heading>
      <ul className='invite-cards u-pad-l_0 u-mar-t_5'>
        {items.map((item) => (
          <InviteStudentsCard {...item} />
        ))}
      </ul>
    </>
  );
};

export default InviteStudentsCards;
